import { TextOutdentIcon } from "@phosphor-icons/react";
import type { Ref } from "react";

/** Expand/collapse toggle for a side drawer. "expand" mirrors the icon so it
 *  points in the direction the panel will move. */
export function DrawerToggleButton({
  direction,
  panel,
  onClick,
  className = "",
  ref,
}: {
  direction: "expand" | "collapse";
  /** Noun used in the aria-label, e.g. "refine panel". */
  panel: string;
  onClick: () => void;
  className?: string;
  ref?: Ref<HTMLButtonElement>;
}) {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      aria-label={`${direction === "expand" ? "Expand" : "Collapse"} ${panel}`}
      className={`rounded-lg text-[var(--text-secondary)] transition hover:text-[var(--text-primary)] ${className}`}
    >
      <TextOutdentIcon
        size={24}
        mirrored={direction === "expand"}
        aria-hidden
        className="shrink-0"
      />
    </button>
  );
}
